export default __webpack_public_path__ + "static/media/sales-network.39af09a6.svg";